const RESULTS_HISTORY_KEY = 'founderDna_results_history_v1';

const safeParseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

const makeId = () => `${Date.now()}_${Math.random().toString(16).slice(2, 10)}`;

const normalizeHistory = (maybeArray) => {
  if (!Array.isArray(maybeArray)) return [];

  // Filter obvious invalid entries and sort newest first
  return maybeArray
    .filter((r) => r && typeof r === 'object' && r.profile && r.createdAt)
    .sort((a, b) => {
      const at = new Date(a.createdAt).getTime();
      const bt = new Date(b.createdAt).getTime();
      return bt - at;
    });
};

export const getResultsHistory = () => {
  const raw = localStorage.getItem(RESULTS_HISTORY_KEY);
  const parsed = safeParseJson(raw);
  return normalizeHistory(parsed);
};

export const addResultsRun = ({ profile, answers = [], createdAt, schemaVersion = 3 }) => {
  if (!profile || !createdAt) return null;

  const history = getResultsHistory();
  const existing = history.find((r) => {
    const sameCreatedAt = r?.createdAt === createdAt;
    const samePrimary = String(r?.profile?.primaryType || '') === String(profile?.primaryType || '');
    return sameCreatedAt && samePrimary;
  });
  if (existing) return existing;

  const nextRun = {
    id: makeId(),
    name: 'Untitled run',
    createdAt,
    profile,
    answers: Array.isArray(answers) ? answers : [],
    schemaVersion,
  };

  // Keep latest first, cap size
  const next = [nextRun, ...history].slice(0, 30);
  localStorage.setItem(RESULTS_HISTORY_KEY, JSON.stringify(next));
  return nextRun;
};

export const renameResultsRun = (runId, name) => {
  const trimmed = String(name || '').trim().slice(0, 60);
  const history = getResultsHistory();
  const next = history.map((run) => {
    if (run.id !== runId) return run;
    return {
      ...run,
      name: trimmed || 'Untitled run',
    };
  });
  localStorage.setItem(RESULTS_HISTORY_KEY, JSON.stringify(next));
  return next;
};

